import React, { useContext } from 'react';
import DropDownToggle from './dropdown-toggle';
import { DropDownContext } from './custom-dropdown';

const DropDownOptionWithToggle = ({ option, onOptionClick, isPresent }) => {
  const { menuWidth = 160 } = useContext(DropDownContext);

  return (
    <div
      style={{ width: menuWidth, minWidth: menuWidth }}
      className={`menu-item menu-toggle-item`}
      onClick={(e) => onOptionClick({ e, option })}
    >
      <div>
        {option.icon && <img src={option.icon.dark} alt="icon" className="icon" />}
        <span>{option.title}</span>
      </div>
      <DropDownToggle option={option} id={1} checked={isPresent(option)} />
    </div>
  );
};

export default DropDownOptionWithToggle;
